/**
 * Ported from `apps/web/lib/bluesky.ts` in `git@git.fugl.dev:sks/yominoki.git` @ `515ce239`.
 */

// Bluesky AT-URI helpers.

const POST_RE = /\/app\.bsky\.feed\.post\/([^/]+)$/;

/**
 * Build a bsky.app post URL from one of:
 *   - a full at-URI: at://did:plc:.../app.bsky.feed.post/<rkey>
 *   - a bare rkey:  3mj5kbl2lbs2r (rkey-only style some ingesters use)
 *
 * Returns null when authorDid is missing or the input doesn't match
 * either shape.
 */
export function blueskyPostUrl(
  authorDid: string | null,
  sourceRefOrUri: string,
): string | null {
  if (!authorDid) return null;
  const m = POST_RE.exec(sourceRefOrUri);
  const rkey = m ? m[1] : looksLikeRkey(sourceRefOrUri) ? sourceRefOrUri : null;
  if (!rkey) return null;
  return `https://bsky.app/profile/${authorDid}/post/${rkey}`;
}

function looksLikeRkey(s: string): boolean {
  // tid-style rkey: 13 lowercase base32-ish chars, no slashes.
  return /^[a-z0-9]{10,16}$/.test(s);
}

const MIN = 60_000;
const HOUR = 60 * MIN;
const DAY = 24 * HOUR;
const WEEK = 7 * DAY;

export function relativeTime(
  when: string | Date | null,
  now = Date.now(),
): string {
  if (!when) return "";
  const t = when instanceof Date ? when.getTime() : Date.parse(when);
  if (Number.isNaN(t)) return "";
  const delta = Math.max(0, now - t);
  if (delta < HOUR) return `${Math.max(1, Math.floor(delta / MIN))}m`;
  if (delta < DAY) return `${Math.floor(delta / HOUR)}h`;
  if (delta < WEEK) return `${Math.floor(delta / DAY)}d`;
  if (delta < 4 * WEEK) return `${Math.floor(delta / WEEK)}w`;
  return `${Math.floor(delta / (30 * DAY))}mo`;
}
